<template>
  <div id="Visit">
    <div id="XyContent">
      <div id="scrollBody">
        <van-list class="refreshWrap" v-model="listLoading" @load="onLoad" finished-text="没有更多了" :finished="finished">
          <visitCard :hoseList="hoseList" :source="'审批'"/>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import visitCard from "@/pages/operationalAnalysis/components/VisitCard.vue";
export default {
  data() {
    return {
      searchName: "",
      VisitState: 0,
      createDate: "",
      listLoading: false,
      finished: false,
      pageIndex: 0,
      pageSize: 10,
      totalItems: 0,
      hoseList: [] //table数据
    };
  },
  components: {
    visitCard
  },
  created: function() {
    //渲染table数据
    var _data = {
      searchName: this.searchName,
      current: this.page,
      size: this.pageSize,
      createDate: this.createDate,
      VisitState: this.VisitState
    };
    this.getTP(_data);
  },
  mounted: function() {},
  methods: {
    async getList() {
      let params = {
        seachText: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        createDate: this.createDate,
        visitState: this.VisitState
      }
      let res = await this.xyapi.get(this.$store.state.apiPath + "/api/Visit/GetPage", params);
      if (res.success) {
        // 加载状态结束
        this.listLoading = false;

        if (res.data.data && res.data.data.length) {
          this.totalItems = res.data.totalRecords
          this.hoseList = this.hoseList.concat(res.data.data)
        } else {
          this.finished = true;
        }

        if (this.hoseList.length >= this.totalItems) {
          this.finished = true;
        }
      }

    },

    onLoad() {
      this.pageIndex++
      this.getList()
    }
  }
};
</script>
<style lang='less' >

</style>

